import { useState } from 'react'

import {
  EquipmentClass,
  buildEquipmentTypeOptions,
} from 'src/graphql/types/drivingExperiences'

import ApplicationRadioQuestion from '../components/ApplicationRadioQuestion'
import ApplicationScreenWrapper from '../components/ApplicationScreenWrapper'
import ApplicationSelectInput from '../components/ApplicationSelectInput'
import ApplicationTextInput from '../components/ApplicationTextInput'
import { useFormLeaveGuard } from '../hooks/useLeaveGuard'
import { useFormContext } from '../utils/FormContext'
import { buildEquipmentPayload } from '../utils/stepPayloads'

const defaultEquipment = {
  type: EquipmentClass.STRAIGHT_TRUCK,
  make: undefined,
  model: undefined,
  year: undefined,
  color: undefined,
  vin: undefined,
  weight: undefined,
  mileage: undefined,
  fifthWheelHeightInches: undefined,
}

export const EquipmentScreen = () => {
  const { form, handleNext, updateLoading, application, backText } =
    useFormContext()
  const { goBack, leaveGuardModal } = useFormLeaveGuard(
    buildEquipmentPayload
  )
  const [hasEquipment, setHasEquipment] = useState(
    form.values.equipment.length > 0
  )

  return (
    <ApplicationScreenWrapper
      title={'Equipment'}
      description={
        'Only applicable to Owner Operators. If you do not have your own truck, Continue to the next section'
      }
      goBack={goBack}
      updateLoading={updateLoading}
      application={application}
      handleCancel={goBack}
      backText={backText}
      saveButtontext={'Save and continue'}
      handleSubmit={() => {
        handleNext(buildEquipmentPayload(form.values))
      }}
    >
      {leaveGuardModal}
      <div className="w-full sm:col-span-3 sm:w-1/3">
        <ApplicationRadioQuestion
          required
          question="Do you have your own vehicle/equipment?"
          value={hasEquipment ? 'true' : 'false'}
          handleChange={(e) => {
            if (e === 'false') {
              setHasEquipment(false)
              form.setFieldValue('equipment', [])
            } else {
              setHasEquipment(true)
              form.setFieldValue('equipment', [
                ...form.values.equipment,
                defaultEquipment,
              ])
            }
          }}
        />
      </div>

      {hasEquipment && (
        <>
          <ApplicationSelectInput
            label="What type of vehicle do you have?"
            placeholder={'Equipment Type'}
            data={buildEquipmentTypeOptions(form.values.equipment[0].type)}
            value={form.values.equipment[0].type}
            error={form.errors[`equipment.${0}.type`] ?? ''}
            onChange={(event) => {
              form.setFieldValue(`equipment.${0}.type`, event.target.value)
            }}
          />
          <ApplicationTextInput
            label="What is the vehicle's make?"
            placeholder={'Make'}
            {...form.getInputProps(`equipment.${0}.make`)}
          />
          <ApplicationTextInput
            label="What is the vehicle's model?"
            placeholder={'Model'}
            {...form.getInputProps(`equipment.${0}.model`)}
          />
          <ApplicationTextInput
            label="What is the vehicle's year?"
            type="number"
            inputMode="numeric"
            placeholder={'Year'}
            {...form.getInputProps(`equipment.${0}.year`)}
          />
          <ApplicationTextInput
            label="What is the vehicle's color?"
            placeholder={'Color'}
            {...form.getInputProps(`equipment.${0}.color`)}
          />
          <ApplicationTextInput
            label="What is the vehicle's mileage?"
            type="number"
            inputMode="numeric"
            placeholder={'Mileage'}
            {...form.getInputProps(`equipment.${0}.mileage`)}
          />
          <ApplicationTextInput
            label="What is the vehicle's VIN?"
            placeholder={'VIN'}
            {...form.getInputProps(`equipment.${0}.vin`)}
          />
          <ApplicationTextInput
            label="What is the vehicle's weight in pounds?"
            type="number"
            inputMode="decimal"
            placeholder={'Weight'}
            {...form.getInputProps(`equipment.${0}.weight`)}
          />
          <ApplicationTextInput
            label="What is the vehicle's height in inches?"
            type="number"
            inputMode="decimal"
            placeholder={'Fifth Wheel Height (inches)'}
            {...form.getInputProps(`equipment.${0}.fifthWheelHeightInches`)}
          />
        </>
      )}
    </ApplicationScreenWrapper>
  )
}
